import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../../components/UI/Button/Button'
import Search from '../../../components/UI/Search/Search'
import Select from '../../../components/UI/Select/Select'
import TimePicker from '../../../components/UI/TimePicker/TimePicker'
import FetchData from '../../../shared/fetchData'
import './LockerAndBoxesReports.css'

const LockerAndBoxesReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [unitId, setUnitId] = React.useState('')
    const [units, setUnits] = React.useState([])
    const [fromHour, setFromHour] = React.useState('')
    const [toHour, setToHour] = React.useState('')
    const [kiosks, setKiosks] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [lockers, setLockers] = React.useState([])
    const [locker, setLocker] = React.useState('')
    const [rerender, setRerender] = React.useState(false)
    const [search, setSearch] = React.useState({
        courierTrackNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شناسه سفارش دهنده'
            },
            validation: {
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })
    const [loading, setLoading] = React.useState(false)
    const [notLockerAndBoxesReports, setLockerAndBoxesReports] = React.useState([])

    React.useEffect(() => {
        var raw = JSON.stringify({
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setUnits(result.units)
                }
            })
            .catch(error => console.log(error))
        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setKiosks(result.kiosks)
                }
            })
            .catch(error => console.log(error))
    }, [])

    const inputChangedHandler = (event) => {
        const srch = search
        srch['courierTrackNumber'].value = event.target.value
        setSearch(srch)
        setRerender(!rerender);
    }
    const changeUnit = selectedOption => {
        setUnitId(selectedOption)
    }
    const changeKiosk = selectedOption => {
        setKiosk(selectedOption)
        var raw = JSON.stringify({
            locker: {
                kiosk: {
                    id: selectedOption.value
                },
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockers/getLockers'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setLockers(result.lockers);
                    setRerender(!rerender);
                }
            })
            .catch(error => console.log(error))
    }
    const changeLocker = selectedOption => {
        setLocker(selectedOption)
    }

    const refresh = (event) => {
        const srch = search
        srch['courierTrackNumber'].value = ""
        setSearch(srch)
        setFrom('')
        setTo('')
        setUnitId('')
        setRerender(!rerender);
    }

    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const changeFromHour = (value) => {
        setFromHour(value)
    }

    const changeToHour = (value) => {
        setToHour(value)
    }
    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "courierTrackNumber": search.courierTrackNumber.value != '' ? "%" + search.courierTrackNumber.value + "%" : null,
                "unitId": unitId != null && unitId != "" ? unitId.value : null,
                "kioskId": kiosk != null && kiosk != "" ? kiosk.value : null,
                "lockerId": locker != null && locker != "" ? locker.value : null,
                "fromTime": fromHour,
                "toTime": toHour,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getLockerAndBoxesReserves'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.orders.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'نام لاکر': o.kiosk != null ? o.kiosk.description : '',
                            'شناسه باکس': o.locker != null ? o.locker.serial : '',
                            "تاریخ ثبت": o.registerDate,
                            "تاریخ شروع": o.startDate,
                            "تاریخ پایان": o.endDate,
                            "ساعت شروع": o.startTime,
                            "ساعت پایان": o.endTime,
                            'سفارش دهنده': o.unit != null ? o.unit.unitName : '',
                            "شناسه سفارش دهنده": o.courierTrackNumber,
                            "شماره سفارش": o.orderNumber,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'LockerAndBoxesReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    const unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }
    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    const lockerList = []
    if (lockers != null && lockers.length != 0) {
        lockers.map(z => {
            lockerList.push({
                value: z.serial,
                label: z.serial + "-" + z.lockerType.description
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">

            <div className="col-4 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={unitId}
                    placeholder="سفارش دهنده"
                    options={unitList}
                    onChange={changeUnit}
                />
            </div>
            <div className="col-4 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={kiosk}
                    placeholder="لاکر"
                    options={kioskList}
                    onChange={changeKiosk}
                />
            </div>
            <div className="col-4 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={locker}
                    placeholder="شناسه باکس"
                    onChange={changeLocker}
                    options={lockerList}
                />
            </div>
            <TimePicker
                onChange={changeFromHour}
                value={fromHour}
                placeHolder="ساعت شروع"
                className="report-time"
                col="4"
            />
            <TimePicker
                onChange={changeToHour}
                value={toHour}
                placeHolder="ساعت پایان"
                className="report-time"
                col="4"
            />



        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-notLockerAndBoxesReports">
            <Search class="orders-search" form={form} />
        </div>
    )
}
export default LockerAndBoxesReports